/**
 * @summary
<blockquote>Determines the appropriate HTTP status code based on error type</blockquote>
 * @internal
 */
import { HTTP_STATUS_CODES, NETWORK_ERROR_TYPES } from '@shared/constants';
import type { HttpStatusCode, NetworkErrorType } from '@shared/constants';

export function getStatusCodeForErrorType(errorType?: NetworkErrorType): HttpStatusCode {
  if (!errorType) return HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR;
  
  switch (errorType) {
    case NETWORK_ERROR_TYPES.AUTHENTICATION:
      return HTTP_STATUS_CODES.UNAUTHORIZED;
    case NETWORK_ERROR_TYPES.AUTHORIZATION:
      return HTTP_STATUS_CODES.FORBIDDEN;
    case NETWORK_ERROR_TYPES.NOT_FOUND:
      return HTTP_STATUS_CODES.NOT_FOUND;
    case NETWORK_ERROR_TYPES.VALIDATION:
      return HTTP_STATUS_CODES.BAD_REQUEST;
    case NETWORK_ERROR_TYPES.RATE_LIMIT:
      return HTTP_STATUS_CODES.TOO_MANY_REQUESTS;
    case NETWORK_ERROR_TYPES.CONNECTION:
    case NETWORK_ERROR_TYPES.TIMEOUT:
    case NETWORK_ERROR_TYPES.DNS:
    case NETWORK_ERROR_TYPES.DATABASE:
      return HTTP_STATUS_CODES.SERVICE_UNAVAILABLE;
    case NETWORK_ERROR_TYPES.SSL:
      return HTTP_STATUS_CODES.BAD_GATEWAY;
    default:
      return HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR;
  }
} 